import { css } from '@genesislcap/web-core';

export const TrancheDetailFlyoutStyles = css`
  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    position: relative;
  }
  
  :host(.resizing) {
    user-select: none;
    cursor: ew-resize;
  }
  
  :host(.resizing) .resize-handle {
    background: var(--accent-fill-active);
    opacity: 0.5;
  }
  
  .resize-handle {
    position: absolute;
    left: -3px;
    top: 0;
    bottom: 0;
    width: 12px;
    background: transparent;
    cursor: ew-resize;
    z-index: 10;
    transition: background-color 0.2s ease;
  }
  
  .resize-handle::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 2px;
    height: 20px;
    background: var(--neutral-stroke-divider-rest);
    border-radius: 1px;
    opacity: 0.4;
  }
  
  .resize-handle:hover {
    background: var(--accent-fill-rest);
    opacity: 0.3;
  }
  
  .resize-handle:hover::before {
    background: var(--accent-foreground-rest);
    opacity: 0.8;
  }
  
  .resize-handle:active {
    background: var(--accent-fill-active);
    opacity: 0.5;
  }
  
  .content {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    padding: 20px;
    overflow-y: auto;
    padding-left: 26px; /* Extra padding to account for resize handle */
  }
  .flyout-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.2em;
    font-weight: bold;
    margin-bottom: 12px;
  }
  .flyout-title {
    flex: 1;
  }
  .flyout-section {
    padding: 10px;
  }
  .flyout-details > div {
    margin-bottom: 6px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }
  .detail-label {
    min-width: 160px;
    color: var(--rapid-ag-header-foreground-color);
    font-size: var(--type-ramp-minus-2-font-size);
    font-weight: 500;
  }
  .detail-value {
    color: var(--neutral-foreground-rest);

    font-size: var(--type-ramp-minus-2-font-size);
    font-weight: 500;
    
  }
  .flyout-form-row {
    display: flex;
    gap: 12px;
    padding-top: 12px;
    min-height: 56px;
    max-height: 56px;
    height: 56px;
    justify-content: end;
    align-items: center;

    font-size: var(--type-ramp-minus-2-font-size);
    font-weight: 500;
  }

  .flyout-form-row > rapid-select {
      min-width: 120px;
      width: 120px;
      font-size: var(--type-ramp-minus-2-font-size);
    font-weight: 500;
  }

  .flyout-form-row > rapid-text-field {
    width: 110px;
    min-width: 110px;
    max-width: 110px;
    margin-bottom: 0px;
    font-size: var(--type-ramp-minus-2-font-size);
    font-weight: 500;
  }

  /* Smaller text variant for inputs */
  rapid-text-field.small-text::part(control) {
    font-size: 12px;
  }

  /* Smaller text variant for selects */
  rapid-select.small-text::part(control) {
    font-size: 12px;
  }

  /* Smaller text variant for buttons */
  rapid-button.small-text::part(control) {
    font-size: 12px;
  }

  .flyout-form-row > rapid-button {
    width: 80px;
    min-width: 80px;
  }

  rapid-tabs {
    background-color: transparent;
  }

  rapid-tab {
    background-color: transparent;
    box-shadow: none;
  }

  rapid-tab[aria-selected='true'] {
    color: var(--neutral-foreground-rest);
    border-bottom: 2px solid var(--accent-foreground-rest);
  }

  rapid-tab-panel {
    background-color: transparent;
  }

  .detail-col {
    display: flex;
    flex-direction: column;
    width: 80px;
  }

  .bid-detail-row {
    display: flex;
    flex-direction: row;
    gap: 10px;
    padding: 10px 10px 20px 10px;
  }

`;
